module.exports = __webpack_public_path__ + "static/media/art33.1d3defa4.jpg";